/** Shared layout + field styles for login, signup, forgot/reset password, and email callback. */

export const authPageBg =
  "flex min-h-screen items-center justify-center bg-zinc-50 px-4";

export const authCard =
  "rounded-2xl border border-zinc-200 bg-white p-8 shadow-sm";

export const authBackLink =
  "mb-8 inline-flex items-center gap-1.5 text-sm text-zinc-500 transition-colors hover:text-zinc-900";

export const authTitle = "text-xl font-bold text-zinc-900";

export const authSubtitle = "mt-1 text-sm text-zinc-500";

export const authLabel = "block text-xs font-medium text-zinc-600";

export const authLabelInline = "text-xs font-medium text-zinc-600";

export const authInput =
  "mt-1.5 h-11 w-full rounded-xl border border-zinc-200 bg-zinc-50 px-4 text-sm text-zinc-900 outline-none placeholder:text-zinc-400 transition-colors focus:border-zinc-400 focus:bg-white";

/** Same as auth input, without top margin (e.g. password under a row label). */
export const authInputFlush =
  "h-11 w-full rounded-xl border border-zinc-200 bg-zinc-50 px-4 text-sm text-zinc-900 outline-none placeholder:text-zinc-400 transition-colors focus:border-zinc-400 focus:bg-white";

export const authPrimaryButton =
  "h-11 w-full rounded-xl bg-gradient-to-r from-orange-500 to-pink-500 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition-all hover:brightness-110 disabled:opacity-50";

/** Outlined control for OAuth providers (e.g. Google). */
export const authOAuthButton =
  "flex h-11 w-full items-center justify-center gap-3 rounded-xl border border-zinc-200 bg-white text-sm font-medium text-zinc-800 shadow-sm transition-colors hover:bg-zinc-50 disabled:pointer-events-none disabled:opacity-50";

export const authOAuthDividerWrap = "relative my-6";

export const authOAuthDividerLine =
  "absolute inset-0 flex items-center aria-hidden";

export const authOAuthDividerBorder = "w-full border-t border-zinc-200";

export const authOAuthDividerLabel =
  "relative flex justify-center text-[11px] font-medium uppercase tracking-wider text-zinc-400";

export const authLinkAccent =
  "font-medium text-orange-500 underline hover:text-orange-600";

export const authFooterText = "mt-6 text-center text-sm text-zinc-500";

export const authFooterLink = "font-semibold text-zinc-900 hover:underline";

export const authNoticeSuccess =
  "rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-950";
